export interface MoECapacitorGeofencePlugin {

  /**
   * Enables geofence monitoring. Required Only if the account is configured for
   * Location-Triggered campaigns
   * 
   * @param appId Account Identifier
   * 
   */
  startGeofenceMonitoring(options: { appId: string }): Promise<void>;

  /**
   * Disables geofence monitoring. To stop receiving Location-Triggered campaigns
   *
   * @param appId Account Identifier
   *
   */
  stopGeofenceMonitoring(options: {appId: string}): Promise<void>;

}
